'use strict'

module.exports = function(value){
    return typeof value === 'number' && isFinite(value)
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/i-s/src/number.js
 ** module id = 853
 ** module chunks = 0
 **/